import type ResponseResult from 'types/response';

import {
  SimplexQuoteRequest,
  SimplexQuoteResponseData,
  SimplexPurchaseRequest,
  SimplexPurchaseResponseData,
} from 'types/simplex';

export const getSimplexQuote = async ({
  end_user_id,
  network,
  digital_currency,
  fiat_currency,
  requested_currency,
  requested_amount,
}: SimplexQuoteRequest): Promise<ResponseResult<SimplexQuoteResponseData>> =>
  fetch(
    process.env.NEXT_PUBLIC_ENV === 'development'
      ? 'https://sifdylhfja.execute-api.ap-northeast-2.amazonaws.com/dev/simplex/quote'
      : 'https://a3w4ujg4j1.execute-api.ap-southeast-1.amazonaws.com/prod/simplex/quote',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        end_user_id,
        network,
        digital_currency,
        fiat_currency,
        requested_currency,
        requested_amount,
      }),
    },
  ).then((res) => res.json());

export const getSimplexPurchase = async ({
  app_end_user_id,
  quote_id,
  currency,
  address,
  network,
}: SimplexPurchaseRequest): Promise<
  ResponseResult<SimplexPurchaseResponseData>
> =>
  fetch(
    process.env.NEXT_PUBLIC_ENV === 'development'
      ? 'https://sifdylhfja.execute-api.ap-northeast-2.amazonaws.com/dev/simplex/partner/data'
      : 'https://a3w4ujg4j1.execute-api.ap-southeast-1.amazonaws.com/prod/simplex/partner/data',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        app_end_user_id,
        quote_id,
        currency,
        address,
        network,
      }),
    },
  ).then((res) => res.json());
